<template>
  <el-dialog
    title="Switch Teams"
    :visible.sync="isVisible"
    :close-on-click-modal="!isSwitchingTeam"
    :close-on-press-escape="!isSwitchingTeam"
    :show-close="!isSwitchingTeam"
    width="30%"
    @closed="$emit('destroy')"
  >
    <TeamSwitcherTeamsList v-model="team" />

    <template #footer>
      <el-button
        :disabled="isSwitchingTeam"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSwitchingTeam"
        @click.native="switchTeam"
      >
        Switch
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import TeamSwitcherTeamsList from '@/components/TeamSwitcher/TeamsList'
import router from '@/router'

export default {
  components: {
    TeamSwitcherTeamsList
  },
  data () {
    return {
      isVisible: true,
      isSwitchingTeam: false,
      teams: [],
      team: undefined
    }
  },
  methods: {
    async switchTeam () {
      this.isSwitchingTeam = true

      if (typeof this.team !== 'undefined' && this.team !== (await this.$session.instance).team.id) {
        await this.$session.switchTeam(this.team)
        router.go()
      }

      this.isSwitchingTeam = false
    }
  }
}
</script>
